import { render, staticRenderFns } from "./ServiceProviderProfile.vue?vue&type=template&id=5df9bce8&scoped=true&"
import script from "./ServiceProviderProfile.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df9bce8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VFlex,VLayout,VSheet})
